/* src/app/home-new/file/file.component.scss */
:host {
  height: auto;
  display: flex;
  width: 100%;
}
:host ::ng-deep ion-radio-group .radio-group-wrapper {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
ion-card {
  padding: 15px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2);
  transition:
    background 0.3s,
    border 0.3s,
    border-radius 0.3s,
    box-shadow 0.3s;
  margin: 0;
  border-radius: 20px;
  width: 100%;
  height: 100%;
}
ion-card .card-header {
  background-color: #f6f6f6;
  border-radius: 10px;
  padding: 5px 10px;
}
ion-card.reduced {
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1215686275);
}
ion-card.reduced .thumbnailDiv {
  min-height: fit-content;
}
ion-card.reduced input {
  border-radius: 5px;
}
ion-card.reduced.showing-grouped-files {
  border-radius: 20px 20px 0 0;
  box-shadow: none;
}
ion-item {
  --min-height: 12px;
  width: 100%;
}
ion-checkbox {
  margin: 0 5px !important;
}
app-file-segment-options {
  width: 100%;
}
.segment-options {
  margin: 10px 0;
}
.segment-options ion-label {
  line-height: 10px;
  font-size: 10px;
  margin: 10px;
}
.segment-options .segment-button-checked {
  background-color: var(--ion-color-primary) !important;
  color: var(--ion-color-primary);
  font-weight: 600;
}
ion-label {
  margin: 0 !important;
}
.move-icon {
  width: 22px;
  height: 22px;
}
.move-icon:hover {
  opacity: 0;
  cursor: url(/src/assets/icon/drag-hover.svg), move !important;
}
.move-icon.active {
  opacity: 0;
  cursor: url(/src/assets/icon/drag-click.svg), move !important;
}
.individual-settings-button {
  margin: 0;
  --border-radius: 100%;
  --ion-color-base: transparent !important;
}
.individual-settings-button::part(native) {
  padding: 8px;
}
.action-button {
  --border-radius: 100%;
  --ion-color-base: transparent !important;
  --ion-color-tint: #ffe2e2 !important;
  margin: 0;
}
.action-button::part(native) {
  padding: 8px;
}
.action-button .action-button_icon {
  width: 20px;
  height: 20px;
  fill: var(--ion-color-danger);
}
.edit-button {
  --background: transparent;
  --background-activated: transparent;
  margin: 0;
  border: 1px solid #949494;
  border-top-right-radius: 10%;
  border-bottom-right-radius: 10%;
  border-left: 1px solid transparent;
}
.edit-button::part(native) {
  padding: 8px;
}
.edit-button:hover {
  --background-hover: #d4ecff;
}
.edit-button .edit-button_icon {
  width: 20px;
  height: 20px;
  fill: #000000;
}
.edit-button .edit-button_save {
  width: 50px;
  height: 20px;
  color: white;
  background-color: #42bff5;
  font-size: 16px;
}
.edit-active {
  background-color: #42bff5;
}
.edit-active:hover {
  --background-hover: #42bff5;
}
.separator {
  background: #949494;
  width: 100%;
  min-width: 1px;
  height: 1px;
  margin: 10px 0;
}
.separator.reduced-margin {
  margin: 5px 0;
}
.separator.vertical {
  width: 1px;
  height: 24px;
  margin: 0 10px;
}
.separator.vertical-arrow {
  width: 1px;
  height: 80%;
  margin: 0 10px;
}
.file-text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: black;
}
.file-text.bold {
  font-weight: 500;
}
.file-text .number-counter {
  color: rgb(0, 154, 207);
  font-weight: 500;
  font-size: 1rem;
}
.file-number-copies-container {
  border: 1px solid #cbcbcb;
  border-radius: 10px;
  padding: 10px;
  width: 100%;
  margin-bottom: 10px;
}
.cover {
  cursor: pointer;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #cbcbcb;
}
.cover img {
  width: 38px;
  height: 40px;
  margin-right: 10px;
}
.cover:hover {
  background-color: #f6f6f6;
}
.cover ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.cover ion-icon.info-icon {
  margin-bottom: 8px;
}
.color ion-radio::part(label) {
  margin-inline-start: 4px;
}
.color ion-radio::part(container) {
  width: 1rem;
  height: 1rem;
}
.color ion-radio.radio-checked::part(container) {
  background: var(--ion-color-primary);
}
.color ion-radio.radio-checked::part(mark) {
  background: white;
}
.coverLaminatedTag {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #259dff;
  padding: 5px 10px 5px 10px;
  border-radius: 20px;
  background-color: #d4ecff;
}
.laminated-cover ion-checkbox {
  margin: 0 !important;
  --size: 18px;
  --checkbox-background-checked: var(--ion-color-primary);
  --checkmark-width: 3px;
}
.laminated-cover ion-checkbox::part(container) {
  border-radius: 3px;
}
.laminated-cover ion-button {
  min-height: unset;
  height: 100%;
}
.laminated-cover ion-button::part(native) {
  padding: 0;
}
.laminated-cover ion-button ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.binding {
  cursor: pointer;
  border-radius: 10px;
}
.binding img,
.binding app-cover-thumbnail {
  width: 20px;
  margin-right: 10px;
}
.binding:hover {
  background-color: #f6f6f6;
}
.binding ion-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.file-container-input {
  width: 100%;
  max-width: 350px;
}
.file-alias-input {
  padding: 7px 5px 8px 5px;
  border: 1px solid #949494;
  border-top-left-radius: 3%;
  border-bottom-left-radius: 3%;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  max-width: 350px;
}
.file-footer {
  margin-top: 10px;
  border-radius: 15px;
  bottom: 10px;
  right: 10px;
  left: 10px;
  width: auto;
}
.file-footer .file-footer_text {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
.file-footer .file-footer_pages {
  display: block;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: 18px;
}
.file-footer .file-footer_price {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #000;
}
.hidden {
  visibility: hidden;
}
.file-index {
  color: black;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 400;
}
ion-checkbox {
  --size: 18px;
}
.properties-container {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 5px;
}
.properties-container svg {
  width: 25px;
  height: 25px;
  fill: var(--ion-color-primary);
}
.property-icon {
  color: rgb(0, 154, 207);
  font-size: 20px;
}
label {
  display: block;
  color: rgb(41, 41, 41);
  font-size: 10px;
}
.file-name {
  font-size: 12px;
  color: rgb(41, 41, 41);
  font-weight: 600;
  text-align: center;
  margin-top: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
ng-lottie {
  display: flex;
  justify-content: center;
  width: 70px;
  height: 70px;
}
.rings {
  position: absolute;
  z-index: 9;
  width: 4px;
}
.rings.portrait {
  height: 4px;
  width: 100%;
  left: 0;
  top: -4px;
}
.rings.portrait.large-side {
  height: 100%;
  width: 4px;
  left: -4px;
  top: 0;
}
.rings.landscape {
  height: 100%;
  width: 4px;
  left: -4px;
  top: 0px;
}
.rings.landscape.large-side {
  height: 4px;
  width: 100%;
  left: 0px;
  top: -4px;
}
.cross {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 4px;
  left: -20px;
}
.cross.landscape {
  top: 4px;
  left: -20px;
}
.cross:after {
  content: "";
  height: 10px;
  border-left: 2px solid rgb(55, 55, 55);
  position: absolute;
  transform: rotate(45deg);
  left: 28px;
}
.cross:before {
  content: "";
  height: 10px;
  border-left: 2px solid rgb(55, 55, 55);
  position: absolute;
  transform: rotate(-45deg);
  left: 28px;
}
img {
  max-width: 100%;
  height: auto;
  max-height: 100%;
  vertical-align: middle;
}
.img-container {
  width: fit-content;
  height: fit-content;
  text-align: center;
  position: relative;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.loading b {
  font-size: 14px;
  color: var(--ion-color-dark);
}
.loading .error {
  min-height: 50px;
  text-align: center;
}
.loading .error b {
  color: red;
}
.loading ion-progress-bar {
  height: 20px;
  --buffer-background: #eee;
}
.no-break {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
h2 {
  margin: 0;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 600;
}
.detailed-message {
  font-weight: 400;
  color: var(--ion-color-dark);
}
.info-text {
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
}
.ion-primary {
  color: var(--ion-color-primary);
}
.flex-column-container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
ion-badge {
  border-radius: 100%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.blankSheetsBtn {
  width: 100%;
}
.blankSheetsBtn ion-icon {
  width: 22px;
}
.blankSheetsBtn span {
  transform: translateY(3px);
}
.thumbnailDiv {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  position: relative;
  align-items: center;
  padding: 0px;
  margin: 0px 30px;
  min-height: 300px;
}
.animacionDiv {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0px;
  min-height: 200px;
  position: relative;
}
.preview {
  opacity: 0.3;
}
.counterImage {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.counterImage.before {
  transform: translate(-15%, 15%);
  width: fit-content;
  height: auto;
}
.counterImage.before.folio-landscape {
  transform: translate(-15%, 15%);
}
.counterImage.after {
  transform: translate(15%, -20%);
  z-index: 0;
  width: fit-content;
  height: auto;
  transform-origin: right top;
}
.counterImage.after.folio-landscape {
  transform: translate(15%, -20%);
}
.counterImage.reduced {
  height: 25px;
}
.counterImage.reduced.before {
  left: -22px;
}
.counterImage.reduced.after {
  right: -22px;
}
.counterImage .sheetNumber {
  position: absolute;
  top: 5%;
  left: 10%;
  z-index: 11;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 500;
  font-size: 12px;
}
.counterImage .sheetNumber.reduced {
  font-size: 8px;
}
.counterImage span {
  text-align: center;
}
.coverLaminatedLabel {
  text-align: center;
  font-weight: 600;
  color: var(--ion-color-primary);
  margin-bottom: 5px;
  width: 100%;
}
.finishings-decorators {
  width: 100%;
  height: 100%;
  position: absolute;
}
.finishings-decorators .finishing-decorators_container {
  position: relative;
  width: 100%;
  height: 100%;
}
.finishings-decorators .finishing-decorators_container .binding-cover {
  height: 100%;
  width: 100%;
}
.finishings-decorators .finishing-decorators_container .binding-holes {
  position: absolute;
  width: 99%;
  height: 5px;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
}
.finishings-decorators .finishing-decorators_container .binding-holes.large-side {
  position: absolute;
  height: 99%;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
}
.finishings-decorators .finishing-decorators_container .binding-holes.landscape {
  position: absolute;
  height: 99%;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
}
.finishings-decorators .finishing-decorators_container .binding-holes.landscape.large-side {
  position: absolute;
  width: 99%;
  height: 5px;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
}
.finishings-decorators .finishing-decorators_container .binding-rings {
  position: absolute;
  width: 99%;
  height: 15px;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
.finishings-decorators .finishing-decorators_container .binding-rings.large-side {
  position: absolute;
  height: 99%;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
}
.finishings-decorators .finishing-decorators_container .binding-rings.landscape {
  position: absolute;
  height: 99%;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
}
.finishings-decorators .finishing-decorators_container .binding-rings.landscape.large-side {
  position: absolute;
  width: 99%;
  height: 15px;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
.finishings-decorators .finishing-decorators_container .perforated2 {
  position: absolute;
  top: 50%;
  height: 52px;
  width: 8px;
  left: 5px;
  transform: translateY(-50%);
}
.finishings-decorators .finishing-decorators_container .perforated4 {
  position: absolute;
  top: 50%;
  height: 148px;
  width: 8px;
  left: 5px;
  transform: translateY(-50%);
}
.finishings-decorators .finishing-decorators_container.landscape .binding-holes {
  position: absolute;
  height: 100%;
  left: 0px;
  width: 5px;
}
.finishings-decorators .finishing-decorators_container.landscape .binding-rings {
  position: absolute;
  height: 100%;
  left: -11px;
  width: 16px;
  opacity: 0.7;
}
.finishings-decorators .finishing-decorators_container.landscape .perforated2 {
  position: absolute;
  top: -1.4em;
  height: 4em;
  width: 8px;
  left: 50%;
  transform: rotate(90deg);
}
.finishings-decorators .finishing-decorators_container.landscape .perforated4 {
  position: absolute;
  top: -4.4em;
  height: 148px;
  width: 8px;
  left: 50%;
  transform: rotate(90deg);
}
.finishings-decorators .finishing-decorators_container .stapled {
  position: absolute;
  top: 10px;
  left: 10px;
}
.finishings-decorators .finishing-decorators_container .laminated {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  filter: brightness(1.6);
}
.reduced .move-icon {
  width: 18px;
  height: 18px;
}
.reduced .index {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  font-size: 16px;
}
.reduced .thumbnailDiv {
  width: 48px;
}
.tooltip-icon {
  width: 14px;
  height: 14px;
  z-index: 99;
  cursor: pointer;
}
@media (max-width: 1104px) {
  .img-container {
    margin-bottom: 20px !important;
  }
  .fileTitle {
    display: block;
    max-width: 65px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .reduced .img-container {
    margin-bottom: unset !important;
    max-width: 50px !important;
  }
  .fileCols {
    width: 100% !important;
  }
  .binding-rings {
    position: absolute !important;
    width: 99% !important;
    height: 16px !important;
    top: -10px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .binding-rings.large-side {
    position: absolute !important;
    height: 99% !important;
    left: -10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 16px !important;
  }
  .binding-rings.landscape {
    position: absolute !important;
    height: 99% !important;
    left: -10px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    width: 16px !important;
  }
  .binding-rings.landscape.large-side {
    position: absolute !important;
    width: 99% !important;
    height: 16px !important;
    top: -10px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .thumbnailDiv {
    min-height: 320px;
  }
  .counterImage.after {
    transform: translate(15%, -25%);
  }
  .counterImage.after.folio-landscape {
    transform: translate(15%, -25%);
  }
}
.container-type {
  border: 1px solid #cbcbcb;
  padding: 10px;
  border-radius: 10px;
}
.tooltip-icon-num-black-pages {
  width: 18px !important;
  height: 18px !important;
  z-index: 99;
  cursor: pointer;
  color: #000;
}
.popover-button-edit-file {
  --width: 170px !important;
}
.despagination-toggle {
  --handle-width: 18px;
  --handle-height: 18px;
}
.despagination-toggle::part(track) {
  width: 42px;
  height: 24px;
}
.disabled {
  opacity: 40%;
}
.disabled * {
  pointer-events: none;
}
.card-wrapper-reduced-mobile {
  position: relative;
  width: 100%;
  min-width: 100px;
  margin-bottom: 16px;
}
.card-wrapper-reduced-mobile .move-icon-container {
  position: absolute;
  top: -5px;
  left: -5px;
  padding: 5px;
  border-radius: 5px;
  background: #f6f6f6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 9;
}
.card-wrapper-reduced-mobile .card-border-wrapper {
  border: 1px solid #949494;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card {
  padding: 0;
  margin: 0;
  width: 100%;
  box-shadow: none;
  --box-shadow: none;
  --border-radius: 0;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card::part(native) {
  margin: 0;
  border-radius: 0;
  box-shadow: none;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .thumbnailDiv {
  margin: 0 0 0 20px;
  width: auto;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card input {
  border-radius: 5px 0 0 5px;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .action-button {
  padding: 5px;
  border-radius: 5px;
  background: #f6f6f6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  width: 32px;
  height: 32px;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .action-button.no-box {
  box-shadow: none;
  background: transparent;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .action-button::part(native) {
  padding: 0;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .card-main {
  padding: 10px;
  position: relative;
  height: 100px;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .card-footer {
  padding: 12px;
  background: #f6f6f6;
  border-top: 1px solid #949494;
  height: 52px;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .card-footer.showing-grouped-files {
  box-shadow: none;
}
.card-wrapper-reduced-mobile .card-border-wrapper ion-card .card-footer .footer-options-title {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-weight: 500;
}
.card-wrapper-reduced-mobile .card-border-wrapper .card-price {
  border-top: 1px solid #949494;
  margin-top: 0;
  border-radius: 0;
}
.card-price {
  display: flex;
  padding: 3px 10px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  border-radius: 12px;
  background: #f6f6f6;
  margin-top: 15px;
}
.card-price .card-price_label {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.card-price .card-price_amount {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
/*# sourceMappingURL=file.component-V2EWDDSD.css.map */
